import { costAnalysisService } from '../../services';

interface IConfig {
  getCostUsageReport: (params: any) => Promise<any>;
  getCategoryOptions: (params: any) => Promise<any>;
  downloadCostReport: (params: any) => Promise<any>;
}

export const config: IConfig = {
  getCostUsageReport: (params: any) =>
    costAnalysisService.getCostUsageReport(params),
  getCategoryOptions: (params: any) =>
    costAnalysisService.getCategoryList(params),
  downloadCostReport: (params: any) =>
    costAnalysisService.downloadCostReport(params),
};

export const formatLabel = (label: string) => {
  return label
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const PARENT_FILTERS = [
  {
    id: 'ProductServiceName',
    label: 'Service',
  },
  {
    id: 'InstanceType',
    label: 'Instance Type',
  },
  {
    id: 'UsageType',
    label: 'Usage Type',
  },
  {
    id: 'ProductRegion',
    label: 'Region',
  },
  {
    id: 'UsageType',
    label: 'Usage Type Group',
  },
  {
    id: 'Operation',
    label: 'API Operation',
  },
  {
    id: 'ProductCode',
    label: 'Resource',
  },
  {
    id: 'ProductRegion',
    label: 'Availability zone',
  },
  {
    id: 'BillingEntity',
    label: 'Billing Entity',
  },
  {
    id: 'LineItemType',
    label: 'Charge Type',
  },
  {
    id: 'OperatingSystem',
    label: 'Platform',
  },
  {
    id: 'PURCHASE_OPTION',
    label: 'Purchase Option',
  },
];
